import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_56mx5j1v94: FaireBrandEntity = {
  token: "b_56mx5j1v94",
  type: "brand",
  name: "Magnum Solace",
  avatarUrl:
    "https://cdn.faire.com/fastly/032096508f1f201f2ff9c883ada1a861553363402b5fd79bb24588f89b7c4339.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a3155cc8ce7e8855a83431d2272c2827ded7198b7ef3ca13149669cac4135d4d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/032096508f1f201f2ff9c883ada1a861553363402b5fd79bb24588f89b7c4339.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a3155cc8ce7e8855a83431d2272c2827ded7198b7ef3ca13149669cac4135d4d.jpeg",
  location: "Houston, TX, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 218,
  isTopShop: true,
  isInsider: true,
  description:
    "Family-owned and hand made since the beginning, our story starts back at the 2008 USA Olympic Swimming Trials.  That's when we started whipping up batches of magnesium oil in our kitchen.  At that time, John (our co-owner) was training for the USA Olympic Swimming Trials. Topical magnesium helped him so much with muscle recovery and sleep, that we were eager to share with our family and friends. That’s when we started to understand just how big of an impact getting enough magnesium can have on health…and there was a unique way to supplement naturally and effectively - through the skin.  Everyone was hooked. Before we knew it, we outgrew our kitchen to meet demand and opened a facility in North Houston that we operate to this day.\n\nBased in Houston, Texas, we’re still family-owned and operated (Marisol, John and the kiddos!)  With new products always in development, we aim to deliver the highest quality and best performing topical magnesium products in the health industry. We're honored to be able to help others feel better, naturally!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:30.004Z",
    importedBy: "entity-db-cli",
  },
};
